import React, { Fragment } from 'react';

import { CrossIcon } from '@vlabs/icons';
import { SideMenu } from '@vlabs/uikit';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useFilterMenu } from './FilterMenuContext';
import './FilterMenu.sass';

export interface FilterMenuProps extends React.PropsWithChildren {
  filters?: React.ReactElement[];
  footer?: React.ReactNode;
  className?: string;
}
function FilterMenu({
  filters = [],
  children = undefined,
  footer = undefined,
  className = undefined,
}: FilterMenuProps): JSX.Element {
  const { isOpen, close } = useFilterMenu();
  const { t } = useTranslation();

  return (
    <div
      className={cn('FilterMenu', {
        FilterMenu_isOpen: isOpen,
      }, className)}
      data-testid="filterMenu"
    >
      <div className="FilterMenu__Header">
        <SideMenu.MenuTitle
          rightIcon={(
            <CrossIcon
              data-testid="closeFiltersButton"
              onClick={close}
            />
          )}
          value={t('filters_title')}
        />
        <div className="FilterMenu__Divider" />
      </div>
      <div className="FilterMenu__Container">
        {filters?.map((filter, filterIdx) => (
          <Fragment key={filter?.key ?? filterIdx}>
            <div className="FilterMenu__Item">{filter}</div>
            <div className={cn('FilterMenu__Divider')} />
          </Fragment>
        ))}
        {children}
      </div>
      <div className="FilterMenu__ButtonGroup">
        {footer}
      </div>
    </div>
  );
}

export { FilterMenu };
